import React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { borderRadii } from 'app/spacing';
import Icon from './Icon';

const HandleIcon = styled(Icon)`
  margin-right: 10px;
  cursor: grab;
  svg {
    color: var(--color-background-dark);
  }
  &:active {
    cursor: grab;
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: var(--color-background-white);
  border: 1px solid var(--color-border-medium);
  border-radius: ${borderRadii.standard};
  padding: 10px;
  outline: none;
  &:hover,
  &:active {
    ${HandleIcon} svg {
      color: var(--color-background-darker);
    }
  }

  ${({ disabled }) =>
    disabled
      ? css`
          background-color: var(--color-background-light);
          && .FieldHandle,
          && .FieldHandle:hover {
            cursor: default;
            svg {
              color: var(--color-background-medium);
            }
          }
        `
      : ''}
`;

const DraggableItem = React.forwardRef(
  ({ handleProps, children, ...others }, ref) => {
    return (
      <Wrapper ref={ref} {...others}>
        <HandleIcon icon="reorder" {...handleProps} />
        {children}
      </Wrapper>
    );
  }
);

DraggableItem.propTypes = {
  handleProps: PropTypes.object,
};

DraggableItem.defaultProps = {
  handleProps: null,
};

DraggableItem.displayName = 'DraggableItem';

export default DraggableItem;
